import { useEffect, useRef, useState } from 'react';
import { useTheme } from 'react-admin';

import { RegenerateReportForm } from '../components/reportComponents/RegenerateReportForm';

import { REGENERATE_STATUSES } from '../../../config/constants/reportConstants';
import { USER_ROLES } from '../../../config/constants/authConstants';
import { apiUrl, httpClient } from '../../../config';
import { platforms } from '../../../helpers/constants';
import { getSelectedIndustryId } from '../../../utils/industryUtils';
import { darkModeStyle } from '../../../utils/styles';

import { filterReportsByType } from '../../../helpers/reportActions';

export const ReportActionsPage = props => {
   const [reports, setReports] = useState([])
   const [reportToRegenerateId, setReportToRegenerateId] = useState(null)
   const [reportToRegenerateLast7DaysId, setReportToRegenerateLast7DaysId] = useState(null)
   const [toShowReportName, setToShowReportName] = useState(null)
   const [isSuccess, setIsSuccess] = useState(null)
   const [role, setRole] = useState(2)
   const [theme] = useTheme()
   const [selectedPlatform, setSelectedPlatform] = useState('')
   const [selectedType, setSelectedType] = useState('')

   const selectRef = useRef()
   const selectLast7DaysRef = useRef()

   const isDarkMode = theme?.palette.mode === 'dark'

   const filteredReports = filterReportsByType({
      reports,
      selectedPlatform,
      selectedType
   });

   useEffect(() => {
      try {
         const doRequest = async () => {
            const industryId = getSelectedIndustryId();
            const response = await httpClient(`${apiUrl}/analytics/report_actions?industry_id=${industryId}`)
            const fetchedReports = JSON.parse(response.body).reports
            setReports(fetchedReports)
         }
         setRole(JSON.parse(localStorage.getItem('user')).role)

         doRequest()
      } catch (err) {
         console.log(err)
      }
   }, [])

   const onUpdateNames = async ({target}) => {
      try {
         target.setAttribute('disabled', 'true')
         target.textContent = 'Updating...'
         target.classList.remove('btn-success')
         target.classList.remove('btn-danger')
         const industryId = getSelectedIndustryId();
         const response = await httpClient(`${apiUrl}/analytics/report_actions/update_names`, {
            method: 'POST',
            body: JSON.stringify({ industry_id: industryId }),
         })
         const data = JSON.parse(response.body)

         if (data.status === 1) {
            target.textContent = 'Done'
            target.classList.add('btn-success')
         } else {
            target.textContent = 'Error, try again'
            target.classList.add('btn-danger')
         }

         target.removeAttribute('disabled')
      } catch (err) {
         console.log(err)
      }
   }

   const onChange = setFunc => ({target}) => {
      setIsSuccess(null)
      setToShowReportName(target.value)
      setFunc(target.value)
   }

   const onMouseOn = async () => {
      const industryId = getSelectedIndustryId();
      const response = await httpClient(`${apiUrl}/analytics/report_actions?industry_id=${industryId}`)
      const fetchedReports = JSON.parse(response.body).reports
      setReports(fetchedReports)
   }

   return (
     <>
        <div className="container content">
           <div className="p-3 mt-4 shadow rounded border">
              <p className="h5">
                 Report actions
              </p>
              {isSuccess === true ?
                <div className="alert alert-success mt-4">
                   Regenerating: {+toShowReportName === 0 ? 'All' : reports.map(report => {
                   if (report.id === +toShowReportName) {
                      return <span>{report.report_name}</span>
                   }
                })}
                </div>
                :
                null
              }
              <div className="d-flex justify-content-between mb-3 row align-items-center">
                 <div className="d-flex justify-content-between align-items-center my-3">
                    <p className="h6">Update report names</p>
                    <div>
                       <button className="btn btn-primary report-checker" onClick={onUpdateNames}>Update</button>
                    </div>
                 </div>
                 <hr/>
                 
                 {/* Platform and Type Selectors */}
                 <div className="row mb-3">
                    <div className="col-4">
                       <label className="form-label mb-2">Select Platform</label>
                       <select
                          name="platform"
                          className="form-select mb-2"
                          onChange={(e) => {
                             setSelectedPlatform(e.target.value);
                             setSelectedType('');
                          }}
                          value={selectedPlatform}
                          style={isDarkMode ? darkModeStyle : {}}
                       >
                          <option value="">Select platform</option>
                          {platforms.map(({ id, name }) => (
                             <option value={id} key={id}>{name}</option>
                          ))}
                       </select>
                    </div>
                    
                    {(selectedPlatform === 'Outbrain' || selectedPlatform === 'Taboola') && (
                       <div className="col-4">
                          <label className="form-label mb-2">Select Type</label>
                          <select
                             name="type"
                             className="form-select mb-2"
                             onChange={(e) => setSelectedType(e.target.value)}
                             value={selectedType}
                             style={isDarkMode ? darkModeStyle : {}}
                          >
                             <option value="">Select Type</option>
                             <option value="ad-data">Ad Data</option>
                             {selectedPlatform === 'Outbrain' ? (
                                <option value="section-data">Section Data</option>
                             ) : (
                                <option value="sites-data">Sites Data</option>
                             )}
                          </select>
                       </div>
                    )}
                 </div>
                 <hr/>
                 <RegenerateReportForm
                  reports={filteredReports}
                  selectRef={selectLast7DaysRef}
                  isDarkMode={isDarkMode}
                  onChange={onChange(setReportToRegenerateLast7DaysId)}
                  onMouseOn={onMouseOn}
                  label="Regenerate report for last 7 days"
                  reportToRegenerateId={reportToRegenerateLast7DaysId}
                  setReportToRegenerateId={setReportToRegenerateLast7DaysId}
                  setIsSuccess={setIsSuccess}
                  status={REGENERATE_STATUSES.UPDATE_7_DAYS}
                 />
                 {role === USER_ROLES.ADMIN && (
                  <RegenerateReportForm
                    reports={filteredReports}
                    selectRef={selectRef}
                    isDarkMode={isDarkMode}
                    onChange={onChange(setReportToRegenerateId)}
                    onMouseOn={onMouseOn}
                    label="Regenerate report"
                    reportToRegenerateId={reportToRegenerateId}
                    setReportToRegenerateId={setReportToRegenerateId}
                    setIsSuccess={setIsSuccess}
                    status={REGENERATE_STATUSES.UPDATE_ENTIRE_REPORT}
                  />
                 )}
              </div>
           </div>
        </div>
     </>
   )
}